import template from './add_objective_to_plan.html';
import * as Utils from '../../lib/savanna_utils.js';

class AddToObjectivePlanViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.title = ko.observable();
		this.employment_info = ko.observable();
		this.objective_plan = ko.observable();
		this.objective_id = ko.observable();
		this.name = ko.observable();
		this.description = ko.observable();
		this.rating_systems = ko.observableArray();
		this.rating_types = ko.observableArray(['Select', 'Multiselect', 'Range', 'Input', 'Number', 'Percentage' ]);
		this.selected_rating_type = ko.observable();
		this.selected_rating_system = ko.observable();
		this.measures = ko.observableArray([]);
		this.selected_measure = ko.observable();
		this.measure_input = ko.observable();
		this.expected_result = ko.observable();
		this.sequence = ko.observable();
		this.linked_to_remove = ko.observableArray();
		this.comp_objectives_to_add = ko.observableArray();

		this.selected_rating_type.subscribe((val) => {
			if (val)
				this.dialog.updateData();
		});

		this.rating_placeholder = ko.computed(() => {
			if (!this.rating_systems().length > 0)
				return 'None available';
		});

		this.selected_measure.subscribe((val) => {
			this.measure_input(val.measure);
		});
	};

	close()
	{
		this.dialog.close();
	}

	async btn_save()
	{
		if (!this.name())
		{
			Grape.alerts.alert({type: 'warning', message: "Objective's name cannot be empty!"});
			return;
		}
		else
		{
			let options = {
				objective_id: this.objective_id() || null,
				objective_plan_id: this.objective_plan().objective_plan_id,
				name: this.name(),
				rating_system_id: this.selected_rating_system(),
				measure: this.measure_input(),
				description: this.description(),
				sequence: this.sequence(),
				expected_result: this.expected_result()
			}
			if (this.comp_objectives_to_add())
			{
				let to_add = this.comp_objectives_to_add().map((item) => ({
					actions: 'link',
					number: item.number,
				}));
				let to_remove = this.linked_to_remove().map((item) => ({
					actions: 'remove',
					number: item.number,
				}));
				options.actions = [...to_add, ...to_remove]
			}

			let res = await Grape.fetches.postJSON('/performance_management/objective/edit', options);

			if (res.status != 'ERROR')
			{
				Grape.alerts.alert({type: 'success', title: 'Success', message: 'Successfully added objective to this objective plan'});
				this.dialog.close();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else 
				Grape.alerts.alert({type: 'error', message: 'An eror occurred while saving the objective'});
		}
	}

	async btn_edit_linked_comp_objectives()
	{
		let data = {
			objective_id: this.objective_id(),
			name: this.name(),
			plan_name: this.objective_plan().name,
			linked_company_objectives: null
		}
		
		let res = await Grape.dialog.open('LinkCompanyObjectives', { data: data, to_add: null, to_remove: null, editing: false, linked_comp_objectives: this.comp_objectives_to_add()});

		if (res)
			this.comp_objectives_to_add(res.comp_objectives_to_add);
	}
};

class AddToObjectivePlanPage
{
	constructor (bindings)
	{
		this.viewModel = new AddToObjectivePlanViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		Utils.refresh_data_visible_roles();
		await this.updateData();

		if (this.bindings)
		{
			this.viewModel.employment_info(ko.mapping.toJS(this.bindings.employee_info));
			this.viewModel.objective_plan(this.bindings.data);
			this.viewModel.title(`Add Objective For ${this.bindings.data.name}`);

			try {
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'measure',
					schema: 'perfm_manage'
				})
	
				if (res.status != 'ERROR')
				{
					this.viewModel.measures(res.records);
				}
			} catch (error) {
				console.error(error);
			}
		}
	}

	async updateData()
	{
		let options = {
			table: 'v_rating_methods',
			schema: 'perfm_manage',
			filter_join: 'AND',
			filter: [{
				field: 'active',
				operand: '=',
				value: true
			}]
		}
		if (this.viewModel.selected_rating_type())
		{
			let type = this.viewModel.selected_rating_type().toString().toLowerCase();
			options.filter.push({
				field: 'rating_method_type',
				operand: '=',
				value: type
			});
		}
		try {
			// API to get the available rating systems to choose from
			let res = await Grape.fetches.getJSON('/api/record', options);

			if (res.status != 'ERROR')
				this.viewModel.rating_systems(res.records);

		} catch (error) {
			console.error(error)
			Grape.alerts.alert({type: 'error', title: 'Error', message : 'An error occurred when loading the Rating Systems'});
		}
	}
};

export default {
	name: 'AddToObjectivePlan',
	dialog_class: AddToObjectivePlanPage,
	template: template,
	template_filename: 'translation/dialogs/add_objective_plan',
	provider: 'ps'
};
